import { Box, Grid } from '@mui/material';
import { upperFirst } from 'lodash';

import { Card, CardContent, Divider, InfoField } from '@occc/ui-design-system';
import { TriggeredMessageViewFragment } from '@occc/graphql';
import { useGetSubBrandByUuid } from '@occc/utils';

import { titleByStatus } from '../../triggered-messages.constants';
import { getTriggeredMessageType } from '../../triggered-messages.utils';

type TriggeredMessageDataProps = {
  message: TriggeredMessageViewFragment;
};

export const TriggeredMessageData = (props: TriggeredMessageDataProps) => {
  const { message } = props;
  const subBrand = useGetSubBrandByUuid(message.subBrandUuid);

  return (
    <Card>
      <CardContent>
        <Box display='flex' flexDirection='column' gap={3}>
          <Grid container spacing={3}>
            <Grid item xs={6} sm={4} md={3}>
              <InfoField
                label='Message Type'
                value={upperFirst(message.messageIntent.toLowerCase())}
                mb={0}
              />
            </Grid>

            <Grid item xs={6} sm={4} md={3}>
              <InfoField label='Message Trigger' value={message.description} mb={0} />
            </Grid>

            <Grid item xs={6} sm={4} md={3}>
              <InfoField label='Status' value={titleByStatus[message.status]} mb={0} />
            </Grid>

            <Grid item xs={6} sm={4} md={3}>
              <InfoField
                label='Message Channel'
                value={getTriggeredMessageType({ channels: message.channelsConfig })}
                mb={0}
              />
            </Grid>

            {subBrand ? (
              <Grid item xs={6} sm={4} md={3}>
                <InfoField label='Sub-brand' value={subBrand.name} mb={0} />
              </Grid>
            ) : null}
          </Grid>

          <Divider />

          <InfoField label='SMS Body' value={message.channelsConfig?.smsConfig?.body} mb={0} />

          <Divider />

          <Grid container spacing={3}>
            <Grid item xs={12} md={4}>
              <InfoField
                label='Push Title'
                value={
                  message.channelsConfig?.pushNotificationConfig?.template?.notification?.title
                }
                mb={0}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <InfoField
                label='Push Body'
                value={message.channelsConfig?.pushNotificationConfig?.template?.notification?.body}
                mb={0}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <InfoField
                label='Deeplink'
                value={message.channelsConfig?.pushNotificationConfig?.template?.data?.url}
                mb={0}
              />
            </Grid>
          </Grid>
        </Box>
      </CardContent>
    </Card>
  );
};
